import React from 'react';
import { useStore } from 'effector-react';
import {
  $GateRotateSubtitleList,
  $rotateCurrentLeft,
} from '@stores/autoRotateStores';
import { PX_PER_SEC } from '../constants';

export function RotateSubtitle() {
  const list = useStore($GateRotateSubtitleList.state);
  const curTimeMs = (useStore($rotateCurrentLeft) / PX_PER_SEC) * 1000;
  if (!list) return null;
  const item = list.find(
    (x) => x.startTime <= curTimeMs && curTimeMs < x.endTime
  );
  if (!item) return null;
  return (
    <div style={{ maxWidth: 600, minWidth: 0 }} className="absolute bottom-70">
      <p className="select-none text-center text-lg text-white line-clamp-2">
        {item.text}
      </p>
    </div>
  );
}
